import { render, staticRenderFns } from "./VerificationSegment.vue?vue&type=template&id=10616620&scoped=true"
import script from "./VerificationSegment.vue?vue&type=script&lang=js"
export * from "./VerificationSegment.vue?vue&type=script&lang=js"
import style0 from "./VerificationSegment.vue?vue&type=style&index=0&id=10616620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10616620",
  null
  
)

export default component.exports